import React from 'react'

export const Footer = () => {
  return (
    <div className='flex flex-col justify-between gap-2 items-center w-full py-4 bg-stone-400 dark:bg-stone-800'>
        <div className='text-white text-center text-xs xl:text-sm 2xl:text-base font-light'>
          Developed by @notalepower<br/>
        </div>
    </div>
  )
}
